








import {Vue, Prop, Component} from "vue-property-decorator";

@Component
export default class QuizProgress extends Vue{
  @Prop({default:0}) readonly value?: number;

}
